<template>
	<vx-card class="comments mb-5">
		<div class="comments__container w-full">
			<h2 class="comments__title mb-4">
				{{ $t("comments") }}
			</h2>

			<div ref="comments" class="comments__list w-full mb-4">
				<div
					v-for="item in commentsList"
					:key="item.id"
					class="comments__item"
				>
					<div class="comments__item-head">
						<p class="comments__item-author">
							{{ item.sender.userName }}
						</p>

						<p class="comments__item-date">
							{{ item.createdAt }}
						</p>
					</div>

					<p class="comments__item-comment">
						{{ item.message }}
					</p>
				</div>
			</div>

			<div class="vx-col w-full mb-2">
				<div
					class="vs-component vs-con-input-label vs-input vs-input-primary mb-4"
				>
					<label class="vs-input--label">{{ $t("comment") }}</label>

					<div class="vs-con-input"></div>
					<vs-textarea
						v-model="comment"
						:disabled="isLoading"
						name="comment"
						v-validate="'required|min:3'"
						class="mb-0"
						height="120px"
					/>
				</div>

				<vs-button
					:disabled="isLoading || !comment"
					@click="setComment"
				>
					{{ $t("send") }}
				</vs-button>
			</div>
		</div>
	</vx-card>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";

export default {
	name: "AuthorsCommentsList",

	mixins: [databaseManager, notifier],

	props: {
		authorId: {
			type: String,
			required: true
		}
	},

	data() {
		return {
			comment: "",
			commentsList: [],
			isLoading: false
		};
	},

	methods: {
		async uploadComments() {
			try {
				this.isLoading = true;
				const res = await this.dbGetAuthorsCommentsList(this.authorId);
				this.commentsList = []
				this.commentsList = res.items.reverse();
			} catch (e) {
				this.notifyError(e.message);
			} finally {
				this.isLoading = false;
			}
		},

		async setComment() {
			try {
				this.isLoading = true;
				const res = await this.dbSetAuthorsCommentsList(
					this.authorId,
					this.comment
				);
				this.commentsList = res.items.reverse();
				this.comment = ''

				await this.scrollDownComments()
			} catch (e) {
				this.notifyError(e.message);
			} finally {
				this.isLoading = false;
			}
		},

		async scrollDownComments() {
			await this.$nextTick(() => {
				this.$refs.comments.scrollTop = 1000000
			})
		}
	},

	async mounted() {
		await this.uploadComments();

		await this.scrollDownComments()

	}
};
</script>

<style scoped lang="scss">
@import "authors-comments-list";
</style>
